"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NODE_KINDS = void 0;

var the_lodash_1 = __importDefault(require("the-lodash"));

var node_kind_1 = require("./entities/node-kind");

exports.NODE_KINDS = the_lodash_1.default.map(node_kind_1.NodeKind, function (x) {
  return x;
});